import angular from 'angular';
import uiRouter from 'angular-ui-router';
import formActionsComponent from './formActions.component';

let formActionsModule = angular.module('formActions', [
  uiRouter
])

.component('formActions', formActionsComponent)

.name;

export default formActionsModule;
